/**
* @file 系统设置-短信管理
* */
<template>
  <div id="sms">
    <tab-frame :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
export default {
  name: "sms",
  data() {
    return {
      // tabs列表
      tabs: [
        { label: "识别记录", name: "/aiCard" },
        { label: "账户配置", name: "/aiConfig" },
          // { label: "短信统计", name: "/smsStatistics" },
      ],
    };
  },
};
</script>

<style lang="less">
</style>
